if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
   // ACCORDION TOGGLE
	document.querySelectorAll('.accordion').forEach(accordion => {
		accordion.querySelectorAll('.accordion_head').forEach(itemHead => {
			itemHead.addEventListener('click', e => {
				accordion.querySelectorAll('.accordion_item').forEach(item => {
					if (itemHead.parentNode !== item) item.classList.remove('active');
				});
				itemHead.parentNode.classList.toggle('active');
			});
		});
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.carousel-slides').slick({
        accessibility: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "20px"
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
      $('.three-columns-slides').slick({
        accessibility: false,
        responsive: [
          {
            breakpoint: 5000,
            settings: "unslick"
          }, 
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
      $('.instagram-gal-slides').slick({
        accessibility: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });


      if(document.getElementById('form_id-1385')) {
        let button = document.querySelector('#form_id-1385 .form-module__submit button');
        button.setAttribute('aria-label', 'request for proposal');
      }

      if( document.getElementById('contactus-form') ) {
        let form = document.getElementById('contactus-form');
        let button = form.querySelector('.form-module__submit button');

        button.setAttribute('aria-label', 'submit form to contact our hotel');
      }

})();